import { render } from "./add_requisition.vue?vue&type=template&id=1fe18a0c"
import script from "./add_requisition.vue?vue&type=script&lang=js"
export * from "./add_requisition.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\OCL-APPLICATION-2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__